import type { ReactNode } from "react";

import { SectionNumber } from "./SectionNumber";

/**
 * One numbered step of the configurator: "1. Warna meja — Walnut".
 *
 * The chosen value is echoed in the heading because swatches carry no visible
 * text, and a shopper should never have to hover to learn what they picked.
 */
export function OptionSection({
  n,
  id,
  title,
  selectedLabel,
  children,
}: {
  n: number;
  id: string;
  title: string;
  selectedLabel?: string;
  children: ReactNode;
}) {
  return (
    <section aria-labelledby={id}>
      <h2 id={id} className="mb-3 flex flex-wrap items-center gap-x-2 gap-y-1 font-medium">
        <SectionNumber n={n} />
        <span>
          {n}. {title}
        </span>
        {selectedLabel && <span className="font-normal text-ink/55">— {selectedLabel}</span>}
      </h2>
      {children}
    </section>
  );
}
